var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(-1496 -2714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    d: "M43,48H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H43a5.006,5.006,0,0,1,5,5V43A5.006,5.006,0,0,1,43,48ZM20.3,26.84a0,0,0,0,0-.005.005v3.831a.718.718,0,0,0,.364.627l6.71,3.838a.722.722,0,0,0,.717,0l8.55-4.912A.725.725,0,0,0,37,29.6v-7.6a.724.724,0,0,0-1.083-.626l-2.264,1.3a.715.715,0,0,0-.265.264.724.724,0,0,0-.1.361l-.013,4.179a.726.726,0,0,1-.362.625l-4.829,2.772a.722.722,0,0,1-.717,0L25.107,29.6a.718.718,0,0,1-.365-.626.722.722,0,0,1,.362-.627l4.1-2.362a.716.716,0,0,0,.362-.625V13.486a.716.716,0,0,0-.359-.625.722.722,0,0,0-.722,0l-7.83,4.5a.721.721,0,0,1-.721,0l-7.833-4.5a.722.722,0,0,0-1.081.625L11,25.349a.724.724,0,0,0,.365.628l2.287,1.308a.735.735,0,0,0,.361.1.724.724,0,0,0,.719-.723v-6.79a.722.722,0,0,1,1.082-.625l4.121,2.372a.726.726,0,0,0,.721,0l4.107-2.368a.721.721,0,0,1,1.083.628l-.011,3.756,0,0,0,0h0a.006.006,0,0,1,0,0,.006.006,0,0,1,0,.007l-5.527,3.174a.009.009,0,0,0,0,.007s0,.011-.005.011ZM36.278,12.793h-.01a.734.734,0,0,0-.362.1L33.74,14.2a.713.713,0,0,0-.351.619v2.648a.721.721,0,0,0,1.092.618l2.168-1.3a.727.727,0,0,0,.351-.62V13.514a.722.722,0,0,0-.722-.72Z",
    transform: "translate(1496 2714)",
    fill: "#ffb400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMui);
export default __webpack_public_path__ + "static/media/MUI.42233b93c6f42867c28ba7c9d3725229.svg";
export { ForwardRef as ReactComponent };